import(/* webpackMode: "eager" */ "/codebuild/output/src889103745/src/festive_qr_code/app/page.js");
